import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import SubProjectProjectTable from './SubProjectProjectTable'
import { cloneDeep } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'
import pathname from '../../../constants/pathname'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import ErrorWidget from '../../errorWidget/ErrorWidget'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getSubprojectMain, searchSubproject } from '../../../redux/actions/accountingSubProject'

export default function SubProjectIncomeAndExpense() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [error, setError] = useState()

  const history = useHistory()
  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getSubprojectMain(projectCode, 1, 5)

      setSchema(response.model)
    } catch (e) {
      console.log('error ', e)
      setError({})
    }
    setIsLoading(false)
  }

  const handleSearch = async (request, pageNum, pagesize) => {
    setIsSearching(true)
    try {
      const response = await searchSubproject(request, projectCode, pageNum, pagesize)
      let _schema = cloneDeep(schema)

      _schema.subProject.data = response.model

      setSchema(_schema)
    } catch (e) {
      console.log('error ', e)
      setError({})
    }
    setIsSearching(false)
  }

  const handleSelected = (data) => {
    sessionSetItemStr('subProjectCode', data.subProjectCode)

    history.push({
      pathname: pathname.incomeAndExpense.SubProjectProjectBasedItems,
    })
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      {isSearching && <OverlayLoader />}

      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        {/* <GoBackButton /> */}

        {schema && (
          <Panel shaded collapsible defaultExpanded bordered style={{ marginTop: 15 }}>
            <MiniProjectInfo schema={schema?.projectInfo} />

            <Panel
              // shaded
              collapsible
              defaultExpanded
              header={schema.subProject.header}
              bordered
              style={{ marginTop: 15 }}
            >
              {schema?.subProject && (
                <SubProjectProjectTable
                  loading={isSearching}
                  schema={schema.subProject}
                  onSearch={handleSearch}
                  onSelect={handleSelected}
                />
              )}
            </Panel>
          </Panel>
        )}

        <br />
      </SidebarProposal>
    </div>
  )
}
